<template>
	<div class="gallery-window-view">
		<div class="slider">
			<div class="image" :style="{ backgroundImage: `url('${images[m_index].src}')` }" @click="$emit('pop')"></div>
		</div>
		<div v-if="images[m_index].info != ''" class="info"><span v-html="images[m_index].info"></span></div>
		<div class="nav">
			<div v-for="(thumb, i) in images" :key="i" :class="{
				thumb: true,
				active: i == m_index
			}" :style="{ backgroundImage: `url('${thumb.src}')` }" @click="m_index = i"></div>
		</div>
	</div>
</template>

<script>
	export default {
		props: ['images', 'index'],
		data() {
			return {
				m_index: 0
			};
		},
		created() {
			this.m_index = this.index;
		}
	}
</script>

<style lang="scss" scoped>
	.gallery-window-view {
		position: absolute;
		font-family: Roboto;
		font-weight: 300;
		font-size: 16px;
		letter-spacing: 0.15px;
		color: rgb(128, 128, 128);
		left: 0;
		top: 0;
		width: 100%;
		height: 100%;

		& > .slider {
			position: absolute;
			left: 0;
			top: 0;
			width: 100%;
			height: 100%;

			& > .image {
				background-position: center center;
				background-size: contain;
				background-repeat: no-repeat;
				
				position: absolute;
				left: 5%;
				top: 10%;
				width: 90%;
				height: 75%;
			}
		}

		& > .info {
			position: absolute;
			left: 0;
			top: 4%;
			width: 100%;
			text-align: center;

			& > span {
				border-radius: 5px;
				padding: 10px 20px 10px 20px;
				background-color: white;
				color: black;
				font-size: 18px;
				font-weight: bold;
				text-transform: uppercase;
			}
		}

		& > .nav {
			position: absolute;
			left: 0;
			bottom: 4%;
			width: 100%;
			text-align: center;

			& > .thumb {
				background-position: center center;
				background-size: cover;
				background-repeat: no-repeat;

				display: inline-block;
				width: 75px;
				height: 75px;
				cursor: pointer;
				margin: 0 5px 0 5px;
				box-sizing: content-box;

				border-bottom: 5px solid rgba(255, 255, 255, 0);

				&.active {
					border-bottom: 5px solid white;
				}
			}
		}
	}
</style>